import { useState, useEffect } from "react";
import { userData } from 'services';

const useFetch = () => {
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        userData(0).then((res: any) => {
            setUserInfo(res.data);
        })
    }, []);

    return [userInfo];
};

export default useFetch;